import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { CleanersScreen } from '@/features/cleaners/routes/cleaners-screen'

export const Route = createFileRoute('/cleaners')({ component: CleanersLayout })

function CleanersLayout() {
  // A cleaner's page owns the whole screen; the list shows when none is open.
  const matches = useMatches()
  const hasChild = matches.some((match) => match.routeId === '/cleaners/$cleanerId')
  return hasChild ? <Outlet /> : <CleanersScreen />
}
